import {toast} from 'sonner';
import {useQuery} from '@tanstack/react-query';
import {LocalStorage} from '@guestapp/core';
import {QUERY_CACHE_KEYS} from 'utils/constants';
import {
  FastAPIServiceError,
  Guidebook,
  LS_I18NEXT_LNG_KEY,
  PaginatedV2,
} from '@guestapp/sdk';
import {useChekinSDK} from 'context/ChekinSDK';

type Props = {
  reservationId: string;
};

function useFetchGuidebooks({reservationId}: Props) {
  const {getGuidebooks} = useChekinSDK();
  const language = LocalStorage.get<string>(LS_I18NEXT_LNG_KEY);
  return useQuery<PaginatedV2<Guidebook>, FastAPIServiceError>(
    [QUERY_CACHE_KEYS.guidebooks, reservationId, language],
    () => getGuidebooks(reservationId),
    {
      enabled: Boolean(reservationId),
      refetchOnWindowFocus: false,
      onError: error => {
        const errorMessage =
          error?.detail && Array.isArray(error.detail)
            ? error.detail[0].msg
            : error?.message || 'An unexpected error occurred';
        toast.error(errorMessage);
      },
    },
  );
}

export {useFetchGuidebooks};
